import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as api from '../../shared/api/apihandler';
import { CasePriority, CaseStage, OpsMaintainItem, OpsMaintenanceCategory, OpsMaintenanceTask, OpsMaintenenceCategoriesContainer, StandardTextsContainer } from '../category-setup/category-setup.component';
import { ActivityCategory, ActivityType } from 'app/shared/models/action.models';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { SubscriptionObject } from 'app/shared/models/standard.models';

@Component({
  selector: 'app-templatemanager',
  templateUrl: './templatemanager.component.html',
  styleUrls: ['./templatemanager.component.css']
})
export class TemplateManagerComponent implements OnInit, OnDestroy {

  constructor(private http: HttpClient, private sharedData: SharedDataService) { }

  standardTexts: StandardTextsContainer = new StandardTextsContainer();
  opsMaintenenceCategories: OpsMaintenenceCategoriesContainer = new OpsMaintenenceCategoriesContainer();
  focus: any;
  rulesTab = 'list';
  ruleState = 'new';
  ruleListState = 'new';
  oldRules = false;
  activityTypes: Array<ActivityTypes>;
  stages: CaseStage;
  priorities: Array<CasePriority>;
  data: Rules = new Rules();
  selectedRules: Array<Rule> = [];
  subs: SubscriptionObject = {}

  ngOnInit(): void {
    this.getStandardTexts();
    this.subs['priorities'] = this.sharedData.priorities().subscribe(data => this.priorities = data.sort((a, b) => a.name < b.name ? -1 : 1));
    //this.getDVCategories();
    this.loadData();
  }

  ngOnDestroy(): void {
    for(let key of Object.keys(this.subs)) this.subs[key].unsubscribe();
  }

  loadData() {
    this.getActivityTypes();
    this.getStages();
    this.getRules();
  }

  //Standard Texts
  getStandardTexts() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<string>(api.jubloApi + 'api/CompanySettings/GetCompanySetting/76efc162-03e5-4310-ae04-30c730c557b7', { headers }).subscribe({
      next: (data) => {
        if (!!data) {
          this.standardTexts.list = JSON.parse(data).texts != null ? JSON.parse(data).texts : [];
          this.standardTexts.textList = this.standardTexts.list.filter(x => x.inMessage == true);
          this.standardTexts.htmlList = this.standardTexts.list.filter(x => x.inOfferHTML == true);
          this.standardTexts.isSaving = false;
        }
      },
      error: err => console.error(err)
    });
  }

  async updateStandardText() {
    this.standardTexts.isSaving = true;
    let saveAble = { categories: null, texts: null };
    saveAble.texts = await this.standardTexts.textList.concat(this.standardTexts.htmlList)
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.post(api.jubloApi + 'api/CompanySettings/AddCompanySetting/76efc162-03e5-4310-ae04-30c730c557b7', saveAble, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => { this.getStandardTexts(); }
    });
  }

  editStandardText(text) {
    console.log(text);
  }

  deleteStandardText(text) {
    console.log(text);
  }

  // Ops and Maintenence Categories
  getDVCategories() {
    this.opsMaintenenceCategories = new OpsMaintenenceCategoriesContainer();
    this.opsMaintenenceCategories.new = new OpsMaintenanceCategory();
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<Array<ActivityCategory>>(api.jubloApi + 'api/Activity/GetDVCategory', { headers }).subscribe({
      next: (data) => {
        console.log(data)
        this.opsMaintenenceCategories.mergeNewCats(data);
        if (!this.opsMaintenenceCategories.tasks) { this.getDVAccountPlan(); }
      },
      error: err => console.error(err)
    });
  }

  addDVCategory() {
    this.focus = null;
    //console.log(this.opsMaintenenceCategories.new)
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.post(api.jubloApi + 'api/Activity/AddDVCategory', { name: this.opsMaintenenceCategories.new.name, parentId: this.opsMaintenenceCategories.new.parentId }, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => { this.getDVCategories(); }
    });
  }

  // createDVFolder() {
  //   const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
  //   this.http.post(api.jubloApi + 'api/Activity/AddDVCategory', {
  //     name: this.opsMaintenenceCategories.newCat,
  //     parentId: this.opsMaintenenceCategories.focusId
  //   }, { headers }).subscribe(
  //     (data) => {
  //     },
  //     (response) => { },
  //     () => {
  //       this.getDVCategories();
  //       this.opsMaintenenceCategories.newCat = '';
  //     }
  //   )
  // }

  deleteDV(id) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    if (this.opsMaintenenceCategories.deleteType == 'cat') {
      this.http.delete(api.jubloApi + 'api/Activity/DeleteDVCategory/' + id, { headers }).subscribe({
        error: err => console.error(err),
        complete: () => {
          this.opsMaintenenceCategories.list = this.opsMaintenenceCategories.list.filter(x => x.id != id);
          this.opsMaintenenceCategories.refresh();
        }
      });
    }
    else if (this.opsMaintenenceCategories.deleteType == 'item') {
      this.http.delete(api.jubloApi + 'api/Activity/DeleteAccountPlan/' + id, { headers }).subscribe({
        error: err => console.error(err),
        complete: () => {
          this.opsMaintenenceCategories.tasks = this.opsMaintenenceCategories.tasks.filter(x => x.id != id);
          this.opsMaintenenceCategories.refresh()
        }
      });
    }
  }

  getDVCategoryNameFromParentId(id) {
    if (id == null) { return '' }
    return this.opsMaintenenceCategories.list.find(x => x.parentId == id).name
  }

  getDVAccountPlan() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<Array<OpsMaintenanceTask>>(api.jubloApi + 'api/Activity/GetAccountPlans', { headers }).subscribe({
      next: (data) => {
        this.opsMaintenenceCategories.tasks = data.filter(x => x.parentId == null).map(x => {
          return {
            categoryId: x.categoryId,
            id: x.id,
            data: x,
            selected: false,
            editing: false,
            hidden: false,
            parentId: x.parentId
          }
        })
        this.opsMaintenenceCategories.allTasks = data.map(x => {
          return {
            categoryId: x.categoryId,
            id: x.id,
            data: x,
            selected: false,
            editing: false,
            hidden: false,
            parentId: x.parentId
          }
        });
      },
      error: err => console.error(err),
      complete: () => {
        this.opsMaintenenceCategories.catToTree(this.opsMaintenenceCategories.list, this.opsMaintenenceCategories.tasks, false);
      }
    });
  }

  createDVItem() {
    let item = this.opsMaintenenceCategories.newItem.data;
    let data = {
      "categoryId": item.categoryId,
      "propertyCost": item.propertyCost,
      "subscription": item.subscription,
      "commonCost": item.commonCost,
      "text": item.text,
      "title": item.title,
      "parentId": null
    }
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.post(api.jubloApi + 'api/Activity/AddAccountPlan', data, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.opsMaintenenceCategories.newItem = new OpsMaintainItem();
        this.getDVAccountPlan();
      }
    });
  }

  dvChildEvent(x: any) {
    let o = this.opsMaintenenceCategories;
    switch (x.type) {
      case ('catRename'): {
        this.updateDVCategory({ id: x.id, name: x.name, parentId: x.parentId });
        let a = o.list.find(y => y.id == x.id);
        a.name = x.name;
        o.refresh();
        break;
      }
      case ('catDragStart'): {
        o.itemDragged = {
          type: 'category',
          id: x.id,
          parentId: x.parentId,
          name: x.name
        };
        break;
      }
      case ('itemDragStart'): {
        o.itemDragged = {
          type: 'item',
          id: x.id,
          parentId: x.parentId
        };
        break;
      }
      case ('itemDragEnd'):
      case ('catDragEnd'): {
        if (o.itemDragged) {
          switch (o.itemDragged.type) {
            case ('item'): {
              if (o.itemDragged != x.id) {
                let a = o.tasks.find(y => y.id == o.itemDragged.id);
                a.categoryId = x.id;
                this.updateAccountPlan(a);
                o.refresh();
              }
              ; break;
            }
            case ('category'): {
              if (o.itemDragged.id != x.id) {
                this.updateDVCategory({ id: o.itemDragged.id, name: o.itemDragged.name, parentId: x.id });
                let a = o.list.find(y => y.id == o.itemDragged.id);
                a.parentId = x.id;
                o.refresh();
              }
              ; break;
            }
          }
        }
        break;
      }
      case ('showChild'): {
        let a = o.list.find(y => y.id == x.data.id);
        a.showChildren = x.data.showChildren;
        a.showItems = x.data.showItems;
        if (a.showChildren == true) {
          this.opsMaintenenceCategories.refocusBranch(a.id);
        }
        break;
      }
      case ('accountDeleted'): {
        if (!!x.categoryId && !!x.id) {
          this.getDVCategories();
        }
        break;
      }
    }
  }

  updateDVCategory(x: OpsMaintenanceCategory) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.put(api.jubloApi + 'api/Activity/AddDVCategory/' + x.id, { name: x.name, parentId: x.parentId }, { headers }).subscribe({
      error: err => console.error(err)
    });
  }

  updateAccountPlan(x: OpsMaintainItem) {
    let data = {
      text: x.data.text,
      propertyCost: x.data.propertyCost,
      subscription: x.data.subscription,
      commonCost: x.data.commonCost,
      parentId: null,
      categoryId: x.categoryId
    }
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.put(api.jubloApi + 'api/Activity/EditAccountPlan/' + x.id, data, { headers }).subscribe({
      error: err => console.error(err)
    });
  }

  getActivityTypes() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<any>(api.jubloApi + 'api/Activity/ActivityTypes', { headers }).subscribe({
      next: (data) => { this.activityTypes = data.sort((a, b) => a.name < b.name ? -1 : 1); },
      error: err => console.error(err)
    });
  }

  getStages() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<any>(api.jubloApi + 'api/Website/Case/GetCaseStages', { headers }).subscribe({
      next: (data) => { this.stages = data; },
      error: err => console.error(err)
    });
  }

  // RULES
  getRules() {
    this.data.rules = [];
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<Array<Rule>>(api.jubloApi + 'api/Activity/GetRules', { headers }).subscribe({
      next: (data) => { 
        this.data.rules = data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()) || a.subject.toLowerCase() < b.subject.toLowerCase() ? -1 : 1);
      },
      error: err => console.error(err),
      complete: () => { this.getRuleLists(); }
    });
  }

  getRuleLists() {
    this.data.ruleLists = [];
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<Array<RuleList>>(api.jubloApi + 'api/Activity/GetRuleLists', { headers }).subscribe({
      next: (data) => this.data.ruleLists = data.sort((a, b) => a.name < b.name ? -1 : 1),
      error: err => console.error(err)
    });
  }

  addRule() {
    this.data.newRule.name = this.data.newRule.subject;
    this.data.newRule.durationInMinutes = this.data.newRule.durationInMinutes * 60;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.post(api.jubloApi + 'api/Activity/AddRule', this.data.newRule, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.data.newRule = new Rule();
        this.ruleState = 'new';
        this.getRules();
      }
    });
  }

  editRule(rule) {
    this.data.editRule = rule;
    this.ruleState = 'editRule';
  }

  updateRule() {
    let data = {
      subject: this.data.editRule.subject,
      name: this.data.editRule.name,
      activityType: this.data.editRule.activityType,
      description: this.data.editRule.description,
      numberOfDays: this.data.editRule.numberOfDays,
      stageId: this.data.editRule.stage.id,
      durationInMinutes: this.data.editRule.durationInMinutes * 60,
      recurrance: this.data.editRule.recurrance,
      priorityId: this.data.editRule.priority.id
    }
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.put(api.jubloApi + 'api/Activity/UpdateRule/' + this.data.editRule.id, data, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => { this.ruleState = 'new'; }
    });
  }

  deleteRule() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.delete(api.jubloApi + 'api/Activity/DeleteRule/' + this.data.editRule.id, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.data.rules = this.data.rules.filter(x => x.id != this.data.editRule.id);
        this.ruleState = 'new';
      }
    });
  }

  addRuleList() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.post(api.jubloApi + 'api/Activity/AddRuleList', this.data.newRuleList, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.data.newRuleList = new NewRuleList();
        this.ruleListState = 'new';
        this.getRuleLists();
      }
    });
  }

  editRuleListItem(list) {
    this.data.editRuleList = list;
    this.ruleListState = 'editList';
  }

  updateRuleList() {
    let data = {
      name: this.data.editRuleList.name,
      stageId: this.data.editRuleList.stage.id
    }
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.put(api.jubloApi + 'api/Activity/UpdateRuleList/' + this.data.editRuleList.id, data, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => { this.ruleListState = 'new'; }
    });
  }

  removeRuleList(id: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.delete(api.jubloApi + 'api/Activity/DeleteRuleList/' + id, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.data.ruleLists = this.data.ruleLists.filter(x => x.id != id);
      }
    });
  }

  onRemoveRuleFromList(event: any) {
    let item = JSON.parse(event);
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.delete(api.jubloApi + 'api/Activity/RemoveRuleFromList/' + item.listId + '/' + item.ruleId, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.data.ruleLists.find(x => x.id == item.listId).rules = this.data.ruleLists.find(x => x.id == item.listId).rules.filter(x => x.id != item.ruleId);
      }
    });
  }

  drag(event: DragEvent, fromId: string) {
    this.data.dragItem = this.data.rules.find(x => x.id == fromId);
  }

  drop(event: DragEvent, toId: string) {
    event.preventDefault();
    this.data.addFileHover = null;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.patch(api.jubloApi + 'api/Activity/AddRuleToList/' + toId + '/' + this.data.dragItem.id, {}, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.getRuleLists();
      }
    });
  }

  selectRule() {
    this.selectedRules = [];
    if (!!this.data.ruleLists.find(x => x.id == this.data.showRulesInList).rules) {
      this.data.ruleLists.find(x => x.id == this.data.showRulesInList).rules.forEach(x => {
        this.selectedRules.push(x);
      });
    }
  }

  addRuleToSelection(rule: Rule) {
    if (!!this.selectedRules && this.selectedRules.find(x => x.id == rule.id)) {
      this.selectedRules = this.selectedRules.filter(x => x.id != rule.id);
    } else {
      this.selectedRules.push(rule);
    }
  }

  checkInList(ruleId: string) {
    if (this.selectedRules.find(x => x.id == ruleId)) {
      return true;
    } else {
      return false;
    }
  }

  saveRulesToList() {
    let oldRules: Array<Rule> = !!this.data.ruleLists.find(x => x.id == this.data.showRulesInList).rules ? this.data.ruleLists.find(x => x.id == this.data.showRulesInList).rules : [];
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    if (oldRules.length == 0) {
      if (this.selectedRules.length > 0) {
        this.selectedRules.forEach(x => {
          this.http.patch(api.jubloApi + 'api/Activity/AddRuleToList/' + this.data.showRulesInList + '/' + x.id, {}, { headers }).subscribe({
            error: err => console.error(err)
          });
        });
      }
    } else {
      let oldIds: string[] = [];
      oldRules.forEach(x => {
        oldIds.push(x.id);
      });
      let idToDelete: string[] = oldIds;
      this.selectedRules.forEach(x => {
        idToDelete = idToDelete.filter(y => y != x.id);
      });

      if (idToDelete.length > 0) {
        idToDelete.forEach(x => {
          this.http.delete(api.jubloApi + 'api/Activity/RemoveRuleFromList/' + this.data.showRulesInList + '/' + x, { headers }).subscribe({
            error: err => console.error(err)
          });
        });
      }

      if (this.selectedRules.length > 0) {

        let idToAdd: string[] = [];
        this.selectedRules.forEach(x => {
          idToAdd.push(x.id);
        });

        if (idToAdd.length > 0) {
          oldIds.forEach(x => {
            idToAdd = idToAdd.filter(y => y != x);
          })
        }

        if (idToAdd.length > 0) {
          idToAdd.forEach(x => {
            this.http.patch(api.jubloApi + 'api/Activity/AddRuleToList/' + this.data.showRulesInList + '/' + x, {}, { headers }).subscribe({
              error: err => console.error(err)
            });
          });
        }
      }
    }
    this.reloadRuleList();
  }

  reloadRuleList() {
    console.log('done - closing modal')
    this.getRules();
    document.getElementById('addRulesToListModalCloseBtn').click();
  }

  allowDrop(event: DragEvent, id: string) {
    event.preventDefault();
    this.data.addFileHover = id;
  }

  showRulesList(id?: string) {
    this.data.showRulesInList = !!id && this.data.showRulesInList != id ? id : null;
  }

  findActivityType(id: string, value: string) {
    return !!this.activityTypes.find(x => x.id == id) ? this.activityTypes.find(x => x.id == id)[value] : '';
  }
  
}

class ActivityTypes {
  icon: string;
  id: string;
  name: string;
  sort: number;
}

export class Rule {
  id: string | null = null;
  subject: string | null = null;
  name: string | null = null;
  description: string | null = null;
  activityType: string | null = null;
  activityTypeId: string | null = null;
  numberOfDays: number = 0;
  stage: IdName;
  stageId: string | null = null;
  recurrance: string | null = null;
  durationInMinutes: number = 0;
  priority: IdName;
  priorityId: string | null = null
}

class IdName {
  id: string | null = null;
  name: string | null = null;
}

class NewRuleList {
  id: string | null = null;
  name: string | null = null;
  stage: IdName;
  stageId: string | null = null;
}

export class RuleList {
  id: string;
  name: string;
  stage: IdName;
  rules: Array<Rule>;
}

class Rules {
  rules: Array<Rule>;
  ruleLists: Array<RuleList>;
  newRule: Rule = new Rule();
  editRule: Rule = new Rule();
  newRuleList: NewRuleList = new NewRuleList();
  editRuleList: NewRuleList = new NewRuleList();
  dragItem: Rule;
  addFileHover: string | null = null;
  showRulesInList: string | null = null;
}